import { Route } from '@/app/router'

const User = () => import('./index.vue')

export default new Route('/users/:id', User).as('Dashboard:User').permissions(['VIEW_USERS'])
